import { render, staticRenderFns } from "./SelectCustomerView.vue?vue&type=template&id=0bef4128&scoped=true"
import script from "./SelectCustomerView.vue?vue&type=script&lang=js"
export * from "./SelectCustomerView.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomerView.vue?vue&type=style&index=0&id=0bef4128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef4128",
  null
  
)

export default component.exports